
export class GetBankListAction {
  static readonly type = '[Masters] GetBankListAction';
}

export class GetTipoChequeListAction {
  static readonly type = '[Masters] GetTipoChequeListAction';
}
export class GetDocumentationLinksAction {
  static readonly type = '[Masters] GetDocumentationLinksAction';
  constructor(public payload: { userType: string }) {}
}
export class GetInstructiveDocumentAction {
  static readonly type = '[Masters] GetInstructiveDocumentAction';
  constructor(public payload: { id: string }) {
  }
}
export class GetInstructiveDocumentTypeAction {
  static readonly type = '[Masters] GetInstructiveDocumentTypeAction';
}
export class GetEstadoChequeListAction {
  static readonly type = '[Masters] GetEstadoChequeListAction';
}
export class GetAllCountriesListAction {
  static readonly type = '[Account] GetAllCountries';
}
export class GetTransaccionTypeListAction {
  static readonly type = '[Masters] GetTransaccionTypeListAction';
}
export class GetBusinessDocumentTypesListAction {
  static readonly type = '[Masters] GetBusinessDocumentTypesListAction';
}
export class GetDocumentsTypeListAction {
  static readonly type = '[Masters] GetDocumentsTypeListAction';
}
export class GetChequeOfertaStatusAction {
  static readonly type = '[Masters] GetChequeOfertaStatusAction';
}
export class GetCantidadHorasVtoOfertasAction {
  static readonly type = '[Masters] GetCantidadHorasVtoOfertasAction';
}
export class GetSocialMediaLinksAction {
  static readonly type = '[Masters] GetSocialMediaLinksAction';
}